import globalEventBus from '@/services/globalEventBus';
import events from '@/domain/events/common';
import store from '@/store';
import { vueNextTick, asyncDelay } from '../asyncHelpers';
import waitEcharts from './waitEcharts';

async function waitRenderFinish() {
  // Processos que devem ser aguardados antes de imprimir
  await Promise.all([
    vueNextTick(),
    waitEcharts(),
  ]);

  // Dando mais um delay extra...
  await asyncDelay(800);
}

async function print() {
  globalEventBus.emit(events.print);
  document.body.dataset.internalPrint = 'true';
  store.dispatch('setPrintingMode', true);
  await waitRenderFinish();

  const callback = () => {
    delete document.body.dataset.internalPrint;
    store.dispatch('setPrintingMode', false);
    window.removeEventListener('afterprint', callback);
  };

  window.addEventListener('afterprint', callback);

  if (document.getElementsByClassName('modal').length > 0) {
    document.getElementById('main').classList.add('no-internal-print');
  }

  window.print();

  document.getElementById('main').classList.remove('no-internal-print');
}

export default print;
